<div class="footer">
	<ng-content></ng-content>
</div>
